import {chatAvatarColor, chatUserInitials} from './chatAppearance';

export default function ChatAvatar({user, className = 'chat-avatar'}) {
    return <span className={className} style={{backgroundColor: chatAvatarColor(user?.id), color: '#fff'}} aria-hidden="true">
        {chatUserInitials(user?.name?.trim() || user?.username)}
    </span>;
}
